import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

/**
 * Service to manage PowerRecall feature flag state
 * Provides centralized access to PowerRecall enablement status
 */
@Injectable({
  providedIn: 'root'
})
export class PowerRecallService {
  private static readonly STORAGE_KEY = 'isPowerRecallEnabled';

  private _isEnabled: boolean;

  constructor(private readonly tokenStorage: TokenStorageService) {
    this._isEnabled = this.getInitialState();
  }

  /**
   * Get current PowerRecall enabled state
   */
  public get isEnabled(): boolean {
    return this._isEnabled;
  }

  /**
   * Set PowerRecall enabled state
   * @param enabled - Whether PowerRecall is enabled
   */
  public setEnabled(enabled: boolean): void {
    localStorage.setItem(PowerRecallService.STORAGE_KEY, enabled.toString());
    this._isEnabled = enabled;
  }

  /**
   * Remove PowerRecall flag from storage and set to false
   */
  public clear(): void {
    localStorage.removeItem(PowerRecallService.STORAGE_KEY);
    this._isEnabled = false;
  }

  /**
   * Helper method to check if PowerRecall card should be displayed
   * Combines all business logic for PowerRecall card visibility
   *
   * @returns true if the PowerRecall card should be shown
   */
  public shouldShowRecallCard(): boolean {
    const powerSuitEidAuthEnabled = this.tokenStorage.userInfo?.CurrentSite?.PowerSuitEidAuthEnabled ?? false;
    const displayInsights = this.tokenStorage.userInfo?.CurrentProgram?.DisplayPowerRecallInsights ?? true;
    return powerSuitEidAuthEnabled && displayInsights && this.isEnabled;
  }

  /**
   * Get initial state from localStorage
   */
  private getInitialState(): boolean {
    const stored = localStorage.getItem(PowerRecallService.STORAGE_KEY);
    return stored === 'true';
  }
}
